module.exports = __webpack_public_path__ + "img/child-companies.d9f59afd.svg";